import Phaser from 'phaser'
import { BootScene } from './BootScene'
import { GameScene } from './GameScene'
import { GameOverScene } from './GameOverScene'
import { DemoScene } from './demo/DemoScene'

const dpr = Math.min(window.devicePixelRatio || 1, 2)
const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

export const GAME_WIDTH = isMobile ? 1600 : 900
export const GAME_HEIGHT = isMobile ? 720 : 650

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.WEBGL,
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: '#dce8f0',
  roundPixels: true,
  scale: {
    mode: isMobile ? Phaser.Scale.ENVELOP : Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    zoom: dpr,
    expandParent: true,
  },
  render: {
    antialias: true,
    roundPixels: true,
    transparent: false,
  },
  scene: [BootScene, GameScene, GameOverScene, DemoScene],
}
